module.exports = __webpack_public_path__ + "static/Bash-b69e063629cfd10ba6018f9ee6db2231.svg";